import React, {useEffect} from 'react'
import AOS from 'aos';
import graphicsDesignServices from "../Assets/Images/graphics-desining-services (1).gif";
import WorkTabs from './WorkTabs';
import CTA from './CTA';


function Work() {

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
      <section className="inner-head" data-aos="fade-up" data-aos-duration="2000" >
        <div className="overlay1">
          <div className="container py-2">
            <div className="row d-flex justify-content-cente align-items-center">
              <div className="col-md-5 head-content">
                <div className="section-header mb-3">
                  <h6>Explore Our Services</h6>
                  <h2>Imaginative Designs, Tangible Impact</h2>
                </div>
                <p>Experience boundless creativity with our graphic design services. Where ideas flourish, we bring your vision to vibrant life, ensuring a lasting impact.</p>
              </div>
              <div className="col-md-7">
                <img src={graphicsDesignServices} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='py-5' data-aos="fade-right" data-aos-duration="2000">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center text-center">
            <div className="col-md-10">
              <div className="section-header">
                <h6>Our portfolio</h6>
                <h2>Projects We've Done So Far</h2>
              </div>
              <p>Explore our portfolio to witness the dedication and 'Zero-Compromise' approach to quality that make us the automatic choice of our clients. Every project at Farooq Graphics speaks volumes about our commitment to excellence. From captivating logos to stunning visuals, our work reflects the meticulous craftsmanship and creative precision that define us. </p>
            </div>
          </div>
        </div>
      </section>

      <WorkTabs />

      <CTA />
    </div>
  )
}

export default Work
